module.exports = __webpack_public_path__ + "img/dept-2.9b73d8f1.svg";